import { useQuery } from '@tanstack/react-query'

import { FailureEnvelop, GetShortVideoViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

export const useGetSingleShort = (slug: string, enabled = false) => {
    const result = useQuery<GetShortVideoViewModel, FailureEnvelop>({
        queryKey: QueryKeys.Interactify.SingleShort(slug),
        queryFn: () =>
            fetchRequest({
                endpoint: `/videos/short-video/slug/${slug}`,
                serviceName: 'cml',
                method: 'GET',
            }),
        enabled: enabled && !!slug,
        staleTime: Infinity,
    })

    return result
}
